import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { _post } from '../../../utils/network';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';
import ListTable from '../../../components/List/ListTable/ListTable.component';
import Pagination from '../../../components/List/Pagination/Pagination.component';

const RequestCategoriesList = () => {
	const { t } = useTranslation();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('request_categories'), link: '/request-categories-list' },
		{ title: t('list') }
	];

	const [requestCategories, setRequestCategories] = useState([]);
	let requestCategoriesListData = {
		head: [t('title'), t('type'), t('status'), t('operation')],
		body: requestCategories.map(requestCategory => [
			requestCategory.requestcategory_name,
			requestCategory.requestcategory_information.type === '1' ? t('marketers_club') : t('portal'),
			<span className={"badge rounded-pill p-2 badge-subtle-" + (requestCategory.is_active ? 'success' : 'secondary')}>
				{requestCategory.is_active ? t('active') : t('deactive')}
			</span>,
			<Link className='btn btn-secondary btn-sm p-1' to={`/request-categories-edit/${requestCategory.requestcategory_id}`}>
				<i className="fa fa-edit"></i> {t('edit')}
			</Link>
		]),
		directions: ['rtl', 'rtl', '', 'ltr']
	};
	
	const [pageNumber, setPageNumber] = useState(1);
	const [pageCounter] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [pagesCount, setPagesCount] = useState(0);
	const [searchRequestCategoryTitle, setSearchRequestCategoryTitle] = useState(null);
	const [searchButtonIsLoading, setSearchButtonIsLoading] = useState(false);
	const [searchCounter, setSearchCounter] = useState(0);
	const getUserCategories = async () => {
		let body = {
			requestcategory_name: searchRequestCategoryTitle,
			page: pageNumber,
			count: pageCounter
		};
		setSearchButtonIsLoading(true);
		let response = await _post('/requestcategories/admin/getAll', body);
		setSearchButtonIsLoading(false);
		switch(response.code){
			case 200:
				setTotalCount(response.data.all_requestcategories);
				setRequestCategories(response.data.requestcategories);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};
	
	const filterRequestCategories = event => {
		event.preventDefault();
		if(searchButtonIsLoading)
			return 0;
		let title = event.target.searchRequestCategoryTitle.value.trim() || null;
		setSearchRequestCategoryTitle(title);
		if(pageNumber === 1)
			setSearchCounter(searchCounter + 1);
		else
			setPageNumber(1);
	};
	
	useEffect(() => {
		setPagesCount(Math.ceil(totalCount / pageCounter));
	}, [totalCount]);
	
	useEffect(() => {
		setSearchCounter(searchCounter + 1);
	}, [pageNumber]);

	useEffect(() => {
		getUserCategories();
	}, [searchCounter]);

	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t('search_for')} {t('request_categories')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={filterRequestCategories}>
						<div className="row gx-2">
							<FormField fieldKey="searchRequestCategoryTitle" title={t('title')} value={searchRequestCategoryTitle} isSearch={true} />
						</div>
						<div>
							<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={searchButtonIsLoading}>
								<i className="fa fa-search"></i> {t('search')}
							</LoadingButton>
						</div>
					</form>
				</div>
			</div>
			<ListTable title={t('request_categories')} pageNumber={pageNumber} pageCounter={pageCounter} totalCount={totalCount} data={requestCategoriesListData} />
			<Pagination pagesCount={pagesCount} action={setPageNumber} />
		</>
	);
};

export default RequestCategoriesList;
